const config = {
  CDN_HOST: 'https://static.pkucarenjk.com/'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js